import { observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject, containerless } from 'aurelia-framework';
import * as condition from './condition';

const FILTER_ALL: any = { filterText: "All" };

@autoinject()
export class FilterPanel {

    constructor() {
        this.isExpanded = false;
    }

    @bindable({ defaultBindingMode: bindingMode.twoWay })   //setting this property from outside does nothing.  It's meant to be set by this control so that host can react
    hasFilter: boolean;

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    isExpanded: boolean;
    isExpandedChanged() {
        if (this.isExpanded) {
            setTimeout(() => this.expander.style.visibility = "visible", 0);
        }
        if (!this.isExpanded) {
            setTimeout(() => this.expander.style.visibility = "hidden", 300);
        }
    }

    expander: any;

    @bindable({ defaultBindingMode: bindingMode.twoWay }) conditions: Array<condition.Condition> = [this.getInitialCondition()];
    conditionsChanged() {
        this.buildFilterCaption();
    }

    @bindable() apply;

    //static _fields: Array<condition.ConditionField>;
    @bindable()
    fields: Array<condition.ConditionField>;

    getInitialCondition() {
        return condition.getDefaultCondition();
    }

    togglePanel() {
        this.isExpanded = !this.isExpanded;
    }

    addCondition(currentCondition: condition.Condition, chainOperator: string) {
        let newCondition = new condition.Condition(chainOperator);
        if (chainOperator == "or") {
            let index = this.conditions.indexOf(currentCondition);
            newCondition.field = currentCondition.field;
            newCondition.operation = currentCondition.operation;
            this.conditions.splice(index + 1, 0, newCondition)
        } else {
            this.conditions.push(newCondition);
        }
    }

    removeCondition(condition) {
        var index = this.conditions.indexOf(condition);
        if (index > -1) {
            this.conditions.splice(index, 1);
        }
        if (this.conditions.length == 0) {
            this.conditions.push(this.getInitialCondition());
        }
    }

    breadcrumbs: Array<any> = [FILTER_ALL];
    buildFilterCaption() {


        let crumbs = [];
        this.conditions.filter(o => typeof o.field == "object").forEach(c => {
            var crumb = { filterText: "", chainOperator: c.chainOperator, condition: c };
            //crumb.filterText = c.chainOperator == "or" ? ' or ' : '';
            crumb.filterText = c.field.label + " " + c.operation.operator;
            if (c.operation.input) {
                crumb.filterText += " " + (typeof c.value == "object" ? c.value.description : c.value);
            }
            crumbs.push(crumb);
        });

        //group breadcrumbs by 'and'
        this.breadcrumbs = [FILTER_ALL];
        crumbs.forEach((c, i) => {
            if (c.chainOperator == "and") {
                //new 'and' group
                c.orCrumbs = [];
                this.breadcrumbs.push(c);
            } else {
                this.breadcrumbs[i].orCrumbs.push(c);
            }
        });
        this.hasFilter = !(this.breadcrumbs.length == 1 && this.breadcrumbs[0] == FILTER_ALL);
    }

    _apply() {
        this.buildFilterCaption();
        this.isExpanded = false;
        this.apply();
    }

    clear() {
        this.conditions = [this.getInitialCondition()];
        setTimeout(() => this._apply(), 0);
    }

    jumpToCondition(condition) {
        var index = this.conditions.indexOf(condition);
        if (index > -1) {
            this.conditions.splice((index + 1));
        } else {
            this.conditions = [this.getInitialCondition()];
        }
        setTimeout(() => this._apply(), 0);
    }
}